import React from 'react';
import { Header as SharedHeader, type AgencyData, type MenuItem } from '@insieme_dev/shared-ui-react';
import appConfig from '../../config/appConfig';

interface HeaderProps {
    agencyData: AgencyData;
    languageSelector: React.ReactElement;
}

const Header: React.FC<HeaderProps> = ({ agencyData, languageSelector }) => {
    const handleMenuItemClick = (item: MenuItem) => {
        console.log('Menu item clicked:', item);
    };

    return (
        <SharedHeader
            agencyData={agencyData}
            languageSelector={languageSelector}
            config={{
                agency: {
                    customPhone: appConfig.agency.customPhone || "",
                    customMobile: appConfig.agency.customMobile || "",
                },
                socialLinks: {
                    whatsapp: appConfig.socialLinks.whatsapp,
                    facebook: appConfig.socialLinks.facebook,
                    instagram: appConfig.socialLinks.instagram,
                    linkedin: appConfig.socialLinks.linkedin,
                },
            }}
            assets={{
                logoPath: "/assets/images/logo.png",
                menuItemsPath: "/locales"
            }}
            className="frontello-header"
            showLoader={true}
            onMenuItemClick={handleMenuItemClick}
        />
    );
};

export default Header;